// This is hardcoded for now, but left in place if we ever want to show quantities for contract
export const SHOW_CONTRACT_QUANTITIES: boolean = false

export const MAX_DISPUTE_ITEMS = 50

/**
 * Where a buyer reaches B-Stock support. Absolute, because support lives on
 * the marketing site rather than this portal, so a relative path breaks
 * wherever the two are served from different hosts.
 */
export const CONTACT_SUPPORT_URL = 'https://bstock.com/contact-us/'
